import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Collapse, Divider, Row, Tooltip } from "antd";
import { useAppDispatch, useAppSelector } from "../../../..";
import HistoryAndPropertyModal from "../../../../components/HistoryAndPropertyModal/HistoryAndPropertyModal";
import { MENU_ADMIN_OFFERING_WRITE } from "../../../../lib/const/permissions";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { ReactComponent as PlusIcon } from "../../../../img/plus.svg";
import { combineClasses } from "../../../../lib/utils/combineClasses";
import { AggregationRulesViewTable } from "../../features/AggregationRulesViewTable/AggregationRulesViewTable";
import { checkIsLoading, useActiveModal } from "../../../../lib/utils";
import {
  aggregationRulesActions,
  fetchAggregationRuleVersions,
} from "../../store/slice/aggregationRulesSlice";
import "./AggregationRulesView.less";

/* ------------------------------------------------------ Начало компонента ------------------------------------------------------ */

interface ComponentProps {
  className?: string;
  activeOfferVersionId?: number;
  priceCreationAllowed?: boolean;
  isProductDetails?: boolean;
}

export const AggregationRulesView = (props: ComponentProps) => {
  const { className, activeOfferVersionId, priceCreationAllowed, isProductDetails } = props;

  const dispatch = useAppDispatch();
  const history = useHistory();

  const location = useLocation();
  const offerFromDate = new URLSearchParams(location.search).get("onDate")?.replace(" ", "+");

  const {
    aggregationRuleVersions,
    aggregationRuleVersionsLoading,
    aggregationRules,
    aggregationRulesLoading,
  } = useAppSelector((state) => state.aggregationRules);

  const { activeModal, setActiveModal, activeModalOptions } = useActiveModal<"history" | "">("");

  const showHistoryModal = (ruleId: number) => {
    if (ruleId) {
      setActiveModal("history", { objectId: ruleId });
    }
  };

  const [collapseKeys, setCollapseKeys] = useState<string | string[]>([]);

  // Открытие раздела, в случае наличия aggregationRules
  useEffect(() => {
    if (aggregationRules.length) {
      setCollapseKeys(["1"]);
    } else {
      setCollapseKeys([]);
    }
  }, [aggregationRules]);

  const onOpenVersion = (aggRuleId: number, isVersionsOpen: boolean) => {
    if (isVersionsOpen) {
      dispatch(aggregationRulesActions.cleanAggregationRuleVersions());
    } else {
      dispatch(fetchAggregationRuleVersions(aggRuleId));
    }
  };

  return (
    <div className={combineClasses("aggregationRules-view", className)}>
      <Divider className="aggregationRules-view__upperDivider" />
      <Collapse
        activeKey={collapseKeys}
        bordered={false}
        onChange={(keys) => {
          setCollapseKeys(keys);
        }}
      >
        <Collapse.Panel
          key="1"
          header={
            <Row justify="space-between" className="aggregationRules-view__pageTitle">
              <h3 id="offering-aggregationRules-title">Группы трафика</h3>
              {priceCreationAllowed && (
                <Tooltip title="Создать группу трафика">
                  <PlusIcon
                    onClick={() => {
                      if (activeOfferVersionId && offerFromDate) {
                        history.push(
                          `/offer/${activeOfferVersionId}/aggregation-rule/create?onDate=${offerFromDate}`
                        );
                      }
                    }}
                    className="serviceRate-edit__addButton"
                  />
                </Tooltip>
              )}
            </Row>
          }
        >
          <Divider style={{ margin: 0 }} />
          <AggregationRulesViewTable
            aggregationRules={aggregationRules}
            showHistoryModal={(ruleId) => {
              showHistoryModal(ruleId);
            }}
            onOpenVersion={onOpenVersion}
            isLoading={checkIsLoading(aggregationRulesLoading)}
            aggregationRuleVersions={aggregationRuleVersions}
            isVersionsLoading={checkIsLoading(aggregationRuleVersionsLoading)}
            isToggleableColumns
            priceCreationAllowed={priceCreationAllowed}
            isProductDetails={isProductDetails}
          />
        </Collapse.Panel>
      </Collapse>
      {activeModalOptions?.objectId && (
        <HistoryAndPropertyModal
          objectTypeSysname="service_agg_rule"
          objectId={activeModalOptions.objectId}
          handleHideModal={() => {
            setActiveModal("");
          }}
          visibleModal={activeModal === "history"}
          hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_WRITE)}
        />
      )}
    </div>
  );
};
